import { MouseEventHandler } from 'react';
import { useStore } from 'hooks';
import { IPhone, IRequestPhone } from 'types';

type Phone =
  | Pick<IPhone, 'add' | 'str_number' | 'code' | 'number'>
  | IRequestPhone;

export const useTelephonyCallback = (phone?: Phone) => {
  const { user, telephony } = useStore();
  const isDisable: boolean = !phone || !user.hasTelephony;

  const trySendCallback: MouseEventHandler = (e) => {
    e.stopPropagation();

    if (!isDisable && phone) {
      const dst =
        phone.add ||
        ('str_number' in phone && phone.str_number) ||
        ('code' in phone ? phone.code : '') + phone.number;

      telephony.makeCallback(dst);
    }
  };

  return {
    trySendCallback,
    isDisable,
  };
};
